<template>
  <div ref="chart" :style="{ width: chartWidth, height: chartHeight }"></div>
</template>

<script>
import * as echarts from "echarts";

export default {
  name: "EChart",
  props: {
    // options: {
    //   type: Object,
    //   required: true,
    // },
    chartWidth: {
      type: String,
      default: "100%",
    },
    chartHeight: {
      type: String,
      default: "200px",
    },
    severe: {
      type: Array,
      default: [],
    },
    moderate: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      chart: null,
      date:[],
    };
  },
  watch: {
    options: {
      handler(options) {
        // this.chart.setOption(options);
      },
      deep: true,
    },
  },
  mounted() {
    // console.log(this.severe, "这是重度颠簸数据");
    // console.log(this.moderate, "这是中度颠簸数据");

    //初始化日期
     this.date = this.common.getDateList(new Date(), 2);
    this.draw()
    // this.chart = echarts.init(this.$refs.chart);
    // this.chart.setOption(this.options);
  },
  methods: {
    //绘制图表数据
    draw() {
      const options = {
        grid: {
          x: 0,
          y: 0,
          x2: 0,
          y2: 0,
          top: "0%",
          left: "0%",
          right: "0%",
          bottom: "0%",
          containLabel: true,
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#999",
            },
          },
        },
        xAxis: [
          {
            type: "category",
            axisTick: {
              show: false,
            },
            interval: 1,
            axisLabel: {
              color: "rgba(255, 255, 255, .5)",
              fontSize: "10px",
            },
            axisLine: {
              show: false,
            },
            data: this.date,
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "",
            min: 0,
            max: 100,
            interval: 20,
            axisLabel: {
              textStyle: {
                //坐标轴颜色
                color: "rgba(36, 173, 254, 1)",
                fontSize: "0",
              },
            },
            //坐标轴线样式
            splitLine: {
              show: true,
              lineStyle: {
                type: "solid", //solid实线;dashed虚线
                color: "rgba(36, 173, 254, 0)",
              },
            },
          },
        ],
        series: [
          {
            name: "中度颠簸",
            data: this.moderate,
            type: "line",
            smooth: true, //true曲线; false折线
            showSymbol: false,
            itemStyle: {
              normal: {
                color: "#DEA15F", //改变折线点的颜色
                lineStyle: {
                  color: "#EBA967", //改变折线颜色
                  type: "solid",
                },
              },
            },
            areaStyle: {
              //折线图颜色半透明
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(235,169,103, 0.5)", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(235,169,103, 0.1)", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
          },
          {
            name: "重度颠簸",
            data: this.severe,
            type: "line",
            smooth: true, //true曲线; false折线
            showSymbol: false,
            itemStyle: {
              normal: {
                color: "#DC5357", //改变折线点的颜色
                lineStyle: {
                  color: "#E07073", //改变折线颜色
                  type: "solid",
                },
              },
            },
            areaStyle: {
              //折线图颜色半透明
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(224,112,115, 0.5)", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(224,112,115, 0.1)", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
          },
        ],
      };

      this.chart = echarts.init(this.$refs.chart);
      this.chart.setOption(options);
    },
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
};
</script>



// WEBPACK FOOTER //
// src/views/bumpprevention/echarts.vue